import type { CountryCode, LanguageCode, OtherFlagCode } from './types';

export const countryFlagNames: Record<CountryCode, string> = {
  ac: 'Ascension Island',
  ad: 'Andorra',
  ae: 'United Arab Emirates',
  'af-emirate': 'Afghanistan',
  af: 'Afghanistan',
  ag: 'Antigua and Barbuda',
  ai: 'Anguilla',
  al: 'Albania',
  am: 'Armenia',
  an: 'Netherlands Antilles',
  ao: 'Angola',
  'aq-true_south': 'Antarctica',
  aq: 'Antarctica',
  ar: 'Argentina',
  as: 'American Samoa',
  at: 'Austria',
  'au-aboriginal': 'Australian Aboriginal',
  'au-act': 'Australian Capital Territory',
  'au-nsw': 'New South Wales',
  'au-nt': 'Northern Territory',
  'au-qld': 'Queensland',
  'au-sa': 'South Australia',
  'au-tas': 'Tasmania',
  'au-torres_strait_islands': 'Torres Strait Islands',
  'au-vic': 'Victoria',
  'au-wa': 'Western Australia',
  au: 'Australia',
  aw: 'Aruba',
  ax: 'Åland Islands',
  az: 'Azerbaijan',
  ba: 'Bosnia and Herzegovina',
  bb: 'Barbados',
  bd: 'Bangladesh',
  be: 'Belgium',
  bf: 'Burkina Faso',
  bg: 'Bulgaria',
  bh: 'Bahrain',
  bi: 'Burundi',
  bj: 'Benin',
  bl: 'Saint Barthélemy',
  bm: 'Bermuda',
  bn: 'Brunei',
  bo: 'Bolivia',
  'bq-bo': 'Bonaire',
  'bq-sa': 'Saba',
  'bq-se': 'Sint Eustatius',
  bq: 'Bonaire',
  br: 'Brazil',
  bs: 'Bahamas',
  bt: 'Bhutan',
  bv: 'Bouvet Island',
  bw: 'Botswana',
  by: 'Belarus',
  bz: 'Belize',
  'ca-bc': 'British Columbia',
  'ca-qc': 'Quebec',
  ca: 'Canada',
  cc: 'Cocos (Keeling) Islands',
  cd: 'Congo, Democratic Republic of the',
  cf: 'Central African Republic',
  cg: 'Congo',
  'ch-gr': 'Grisons',
  ch: 'Switzerland',
  ci: 'Ivory Coast',
  ck: 'Cook Islands',
  cl: 'Chile',
  cm: 'Cameroon',
  'cn-hk': 'Hong Kong',
  'cn-xj': 'Xinjiang',
  cn: 'China',
  co: 'Colombia',
  cp: 'Clipperton Island',
  cq: 'Sark',
  cr: 'Costa Rica',
  cu: 'Cuba',
  cv: 'Cabo Verde',
  cw: 'Curaçao',
  cx: 'Christmas Island',
  cy: 'Cyprus',
  cz: 'Czechia',
  de: 'Germany',
  dg: 'British Indian Ocean Territory',
  dj: 'Djibouti',
  dk: 'Denmark',
  dm: 'Dominica',
  do: 'Dominican Republic',
  dz: 'Algeria',
  ea: 'Ceuta',
  east_african_federation: 'East African Federation',
  easter_island: 'Easter Island',
  'ec-w': 'Galápagos',
  ec: 'Ecuador',
  ee: 'Estonia',
  eg: 'Egypt',
  eh: 'Western Sahara',
  er: 'Eritrea',
  'es-ar': 'Aragon',
  'es-ce': 'Ceuta',
  'es-cn': 'Canary Islands',
  'es-ct': 'Catalonia',
  'es-ga': 'Galicia',
  'es-ib': 'Balearic Islands',
  'es-ml': 'Melilla',
  'es-pv': 'Basque Country',
  'es-variant': 'Spain',
  es: 'Spain',
  'et-af': 'Afar',
  'et-am': 'Amhara',
  'et-be': 'Benishangul-Gumuz',
  'et-ga': 'Gambela',
  'et-ha': 'Harari',
  'et-or': 'Oromia',
  'et-si': 'Sidama',
  'et-sn': "Southern Nations, Nationalities, and Peoples' Region",
  'et-so': 'Somali',
  'et-sw': 'South West Region',
  'et-ti': 'Tigray',
  et: 'Ethiopia',
  eu: 'European Union',
  european_union: 'European Union',
  ewe: 'Ewe',
  fi: 'Finland',
  fj: 'Fiji',
  fk: 'Falkland Islands (Malvinas)',
  fm: 'Micronesia',
  fo: 'Faroe Islands',
  'fr-20r': 'Corsica',
  'fr-bre': 'Brittany',
  'fr-cp': 'Clipperton Island',
  fr: 'France',
  fx: 'France',
  ga: 'Gabon',
  'gb-con': 'Cornwall',
  'gb-eng': 'England',
  'gb-nir': 'Northern Ireland',
  'gb-ork': 'Orkney',
  'gb-sct': 'Scotland',
  'gb-wls': 'Wales',
  gb: 'United Kingdom',
  gd: 'Grenada',
  'ge-ab': 'Abkhazia',
  ge: 'Georgia',
  gf: 'French Guiana',
  gg: 'Guernsey',
  gh: 'Ghana',
  gi: 'Gibraltar',
  gl: 'Greenland',
  gm: 'Gambia',
  gn: 'Guinea',
  gp: 'Guadeloupe',
  gq: 'Equatorial Guinea',
  gr: 'Greece',
  gs: 'South Georgia and the South Sandwich Islands',
  gt: 'Guatemala',
  gu: 'Guam',
  guarani: 'Guarani',
  gw: 'Guinea-Bissau',
  gy: 'Guyana',
  hausa: 'Hausa',
  hk: 'Hong Kong',
  hm: 'Heard Island and McDonald Islands',
  hmong: 'Hmong',
  hn: 'Honduras',
  hr: 'Croatia',
  ht: 'Haiti',
  hu: 'Hungary',
  ic: 'Canary Islands',
  'id-jb': 'West Java',
  'id-jt': 'Central Java',
  id: 'Indonesia',
  ie: 'Ireland',
  il: 'Israel',
  im: 'Isle of Man',
  'in-as': 'Assam',
  'in-gj': 'Gujarat',
  'in-ka': 'Karnataka',
  'in-mn': 'Manipur',
  'in-mz': 'Mizoram',
  'in-or': 'Odisha',
  'in-tg': 'Telangana',
  'in-tn': 'Tamil Nadu',
  in: 'India',
  io: 'British Indian Ocean Territory',
  'iq-kr': 'Kurdistan',
  iq: 'Iraq',
  ir: 'Iran',
  is: 'Iceland',
  'it-21': 'Piedmont',
  'it-23': 'Aosta Valley',
  'it-25': 'Lombardy',
  'it-32': 'Trentino-Alto Adige',
  'it-34': 'Veneto',
  'it-36': 'Friuli Venezia Giulia',
  'it-42': 'Liguria',
  'it-45': 'Emilia-Romagna',
  'it-52': 'Tuscany',
  'it-55': 'Umbria',
  'it-57': 'Marche',
  'it-62': 'Lazio',
  'it-65': 'Abruzzo',
  'it-67': 'Molise',
  'it-72': 'Campania',
  'it-75': 'Apulia',
  'it-77': 'Basilicata',
  'it-78': 'Calabria',
  'it-82': 'Sicily',
  'it-88': 'Sardinia',
  it: 'Italy',
  je: 'Jersey',
  jm: 'Jamaica',
  jo: 'Jordan',
  jp: 'Japan',
  kanuri: 'Kanuri',
  ke: 'Kenya',
  kg: 'Kyrgyzstan',
  kh: 'Cambodia',
  ki: 'Kiribati',
  kikuyu: 'Kikuyu',
  km: 'Comoros',
  kn: 'Saint Kitts and Nevis',
  kongo: 'Kongo',
  kp: 'North Korea',
  kr: 'South Korea',
  kw: 'Kuwait',
  ky: 'Cayman Islands',
  kz: 'Kazakhstan',
  la: 'Laos',
  lb: 'Lebanon',
  lc: 'Saint Lucia',
  li: 'Liechtenstein',
  lk: 'Sri Lanka',
  lr: 'Liberia',
  ls: 'Lesotho',
  lt: 'Lithuania',
  lu: 'Luxembourg',
  lv: 'Latvia',
  ly: 'Libya',
  ma: 'Morocco',
  malayali: 'Malayali',
  maori: 'Maori',
  mc: 'Monaco',
  md: 'Moldova',
  me: 'Montenegro',
  mf: 'Saint-Martin',
  mg: 'Madagascar',
  mh: 'Marshall Islands',
  mk: 'North Macedonia',
  ml: 'Mali',
  mm: 'Myanmar',
  mn: 'Mongolia',
  mo: 'Macao',
  mp: 'Northern Mariana Islands',
  'mq-old': 'Martinique',
  mq: 'Martinique',
  mr: 'Mauritania',
  ms: 'Montserrat',
  mt: 'Malta',
  mu: 'Mauritius',
  mv: 'Maldives',
  mw: 'Malawi',
  mx: 'Mexico',
  my: 'Malaysia',
  mz: 'Mozambique',
  na: 'Namibia',
  nc: 'New Caledonia',
  ne: 'Niger',
  nf: 'Norfolk Island',
  ng: 'Nigeria',
  ni: 'Nicaragua',
  'nl-fr': 'Friesland',
  nl: 'Netherlands',
  no: 'Norway',
  northern_cyprus: 'Northern Cyprus',
  np: 'Nepal',
  nr: 'Nauru',
  nu: 'Niue',
  nz: 'New Zealand',
  occitania: 'Occitania',
  om: 'Oman',
  otomi: 'Otomi',
  pa: 'Panama',
  pe: 'Peru',
  pf: 'French Polynesia',
  pg: 'Papua New Guinea',
  ph: 'Philippines',
  'pk-jk': 'Azad Kashmir',
  'pk-sd': 'Sindh',
  pk: 'Pakistan',
  pl: 'Poland',
  pm: 'Saint Pierre and Miquelon',
  pn: 'Pitcairn Islands',
  pr: 'Puerto Rico',
  ps: 'Palestine',
  'pt-20': 'Azores',
  'pt-30': 'Madeira',
  pt: 'Portugal',
  pw: 'Palau',
  py: 'Paraguay',
  qa: 'Qatar',
  quechua: 'Quechua',
  re: 'Réunion',
  ro: 'Romania',
  rs: 'Serbia',
  'ru-ba': 'Bashkortostan',
  'ru-ce': 'Chechnya',
  'ru-cu': 'Chuvashia',
  'ru-da': 'Dagestan',
  'ru-dpr': "Donetsk People's Republic",
  'ru-ko': 'Komi Republic',
  'ru-lpr': "Luhansk People's Republic",
  'ru-ta': 'Tatarstan',
  'ru-ud': 'Udmurtia',
  ru: 'Russia',
  rw: 'Rwanda',
  sa: 'Saudi Arabia',
  sami: 'Sami',
  sb: 'Solomon Islands',
  sc: 'Seychelles',
  sd: 'Sudan',
  se: 'Sweden',
  sg: 'Singapore',
  'sh-ac': 'Ascension Island',
  'sh-hl': 'Saint Helena',
  'sh-ta': 'Tristan da Cunha',
  sh: 'Saint Helena',
  si: 'Slovenia',
  sj: 'Svalbard and Jan Mayen',
  sk: 'Slovakia',
  sl: 'Sierra Leone',
  sm: 'San Marino',
  sn: 'Senegal',
  so: 'Somalia',
  somaliland: 'Somaliland',
  south_ossetia: 'South Ossetia',
  soviet_union: 'Soviet Union',
  sr: 'Suriname',
  ss: 'South Sudan',
  st: 'São Tomé and Príncipe',
  su: 'West Java',
  sv: 'El Salvador',
  sx: 'Sint Maarten',
  'sy-sar': 'Syria',
  sy: 'Syria',
  sz: 'Eswatini',
  ta: 'Tristan da Cunha',
  tc: 'Turks and Caicos Islands',
  td: 'Chad',
  tf: 'French Southern Territories',
  tg: 'Togo',
  th: 'Thailand',
  tibet: 'Tibet',
  tj: 'Tajikistan',
  tk: 'Tokelau',
  tl: 'Timor-Leste',
  tm: 'Turkmenistan',
  tn: 'Tunisia',
  to: 'Tonga',
  tr: 'Turkey',
  transnistria: 'Transnistria',
  tt: 'Trinidad and Tobago',
  tv: 'Tuvalu',
  tw: 'Taiwan',
  tz: 'Tanzania',
  ua: 'Ukraine',
  ug: 'Uganda',
  uk: 'United Kingdom',
  um: 'United States Minor Outlying Islands',
  un: 'United Nations',
  'us-ak': 'Alaska',
  'us-al': 'Alabama',
  'us-ar': 'Arkansas',
  'us-as': 'American Samoa',
  'us-az': 'Arizona',
  'us-betsy_ross': 'Betsy Ross',
  'us-ca': 'California',
  'us-co': 'Colorado',
  'us-confederate_battle': 'Confederate battle',
  'us-dc': 'District of Columbia',
  'us-fl': 'Florida',
  'us-ga': 'Georgia',
  'us-gu': 'Guam',
  'us-hi': 'Hawaii',
  'us-in': 'Indiana',
  'us-mn': 'Minnesota',
  'us-mo': 'Missouri',
  'us-mp': 'Northern Mariana Islands',
  'us-ms': 'Mississippi',
  'us-nc': 'North Carolina',
  'us-nm': 'New Mexico',
  'us-pr': 'Puerto Rico',
  'us-ri': 'Rhode Island',
  'us-tn': 'Tennessee',
  'us-tx': 'Texas',
  'us-um': 'United States Minor Outlying Islands',
  'us-vi': 'Virgin Islands (U.S.)',
  us: 'United States of America',
  uy: 'Uruguay',
  uz: 'Uzbekistan',
  va: 'Holy See (Vatican)',
  vc: 'Saint Vincent and the Grenadines',
  ve: 'Venezuela',
  vg: 'Virgin Islands (British)',
  vi: 'Virgin Islands (U.S.)',
  vn: 'Vietnam',
  vu: 'Vanuatu',
  wf: 'Wallis and Futuna',
  wiphala: 'Wiphala',
  ws: 'Samoa',
  xk: 'Kosovo',
  xx: '<Placeholder>',
  ye: 'Yemen',
  yorubaland: 'Yorubaland',
  yt: 'Mayotte',
  yu: 'Yugoslavia',
  za: 'South Africa',
  zm: 'Zambia',
  zw: 'Zimbabwe',
};

export const otherFlagNames: Record<OtherFlagCode, string> = {
  checkered: 'Checkered',
  chequered: 'Chequered',
  earth: 'Earth',
  jolly_roger: 'Jolly Roger',
  klingon: 'Klingon',
  'lgbt-progress': 'LGBT Progress',
  'lgbt-transgender': 'Transgender',
  lgbt: 'LGBT',
  mars: 'Mars',
  nato: 'NATO',
  olympics: 'Olympics',
  pirate: 'Pirate',
  un: 'United Nations',
  united_nations: 'United Nations',
  amsterdam: 'Amsterdam',
  galactic_empire: 'Galactic Empire',
  rebel_alliance: 'Rebel Alliance',
};

export const languageNames: Record<LanguageCode, string> = {
  aa: 'Afar',
  ab: 'Abkhazian',
  af: 'Afrikaans',
  ak: 'Akan',
  am: 'Amharic',
  an: 'Aragonese',
  ar: 'Arabic',
  as: 'Assamese',
  av: 'Avaric',
  ay: 'Aymara',
  az: 'Azerbaijani',
  ba: 'Bashkir',
  be: 'Belarusian',
  bg: 'Bulgarian',
  bi: 'Bislama',
  bm: 'Bambara',
  bn: 'Bengali',
  bo: 'Tibetan',
  br: 'Breton',
  bs: 'Bosnian',
  ca: 'Catalan, Valencian',
  ce: 'Chechen',
  ceb: 'Cebuano',
  ch: 'Chamorro',
  chm: 'Mari',
  ckb: 'Central Kurdish',
  co: 'Corsican',
  cs: 'Czech',
  cv: 'Chuvash',
  cy: 'Welsh',
  da: 'Danish',
  de: 'German',
  dv: 'Divehi, Dhivehi, Maldivian',
  dz: 'Dzongkha',
  ee: 'Ewe',
  el: 'Modern Greek',
  'en-au': 'Australian English',
  'en-ca': 'Canadian English',
  'en-gh': 'Ghanaian English',
  'en-hk': 'Hong Kong English',
  'en-ie': 'Irish English',
  'en-in': 'Indian English',
  'en-ke': 'Kenyan English',
  'en-ng': 'Nigerian English',
  'en-nz': 'New Zealand English',
  'en-ph': 'Philippine English',
  'en-sg': 'Singaporean English',
  'en-tz': 'Tanzanian English',
  'en-us': 'US English',
  'en-za': 'South African English',
  en: 'English',
  eo: 'Esperanto',
  'es-mx': 'Mexican Spanish',
  es: 'Spanish',
  et: 'Estonian',
  eu: 'Basque',
  fa: 'Persian',
  fi: 'Finnish',
  fj: 'Fijian',
  fo: 'Faroese',
  fr: 'French',
  fy: 'Western Frisian',
  ga: 'Irish',
  gd: 'Gaelic, Scottish Gaelic',
  gl: 'Galician',
  gn: 'Guarani',
  gu: 'Gujarati',
  gv: 'Manx',
  ha: 'Hausa',
  haw: 'haw',
  he: 'Hebrew',
  hi: 'Hindi',
  hmn: 'hmn',
  ho: 'Hiri Motu',
  hr: 'Croatian',
  ht: 'Haitian, Haitian Creole',
  hu: 'Hungarian',
  hy: 'Armenian',
  ia: 'Interlingua',
  id: 'Indonesian',
  ie: 'Interlingue, Occidental',
  ig: 'Igbo',
  ilo: 'Iloko',
  interslavic: 'Interslavic',
  io: 'Ido',
  is: 'Icelandic',
  it: 'Italian',
  ja: 'Japanese',
  jv: 'Javanese',
  ka: 'Georgian',
  kg: 'Kongo',
  ki: 'Kikuyu, Gikuyu',
  kk: 'Kazakh',
  kl: 'Kalaallisut, Greenlandic',
  km: 'Central Khmer',
  kn: 'Kannada',
  ko: 'Korean',
  kr: 'Kanuri',
  kri: 'Krio',
  ks: 'Kashmiri',
  ku: 'Kurdish',
  kv: 'Komi',
  kw: 'Cornish',
  ky: 'Kirghiz, Kyrgyz',
  la: 'Latin',
  lb: 'Luxembourgish, Letzeburgesch',
  lg: 'Ganda',
  ln: 'Lingala',
  lo: 'Lao',
  lt: 'Lithuanian',
  lu: 'Luba-Katanga',
  lus: 'Lushai',
  lv: 'Latvian',
  mg: 'Malagasy',
  mh: 'Marshallese',
  mi: 'Maori',
  mk: 'Macedonian',
  ml: 'Malayalam',
  mn: 'Mongolian',
  mni: 'Manipuri',
  mr: 'Marathi',
  mrj: 'Hill Mari',
  ms: 'Malay',
  mt: 'Maltese',
  my: 'Burmese',
  na: 'Nauru',
  nb: 'Norwegian Bokmål',
  nd: 'North Ndebele',
  ne: 'Nepali',
  nl: 'Dutch, Flemish',
  nn: 'Norwegian Nynorsk',
  no: 'Norwegian',
  non: 'Old Norse',
  nr: 'Navajo, Navaho',
  ny: 'Chichewa, Chewa, Nyanja',
  oc: 'Occitan',
  om: 'Oromo',
  or: 'Oriya',
  os: 'Ossetian, Ossetic',
  oto: 'Oto-Pamean',
  pa: 'Punjabi, Panjabi',
  pap: 'Papiamento',
  pl: 'Polish',
  pms: 'Piedmontese',
  ps: 'Pashto, Pushto',
  'pt-br': 'Brazilian Portuguese',
  pt: 'Portuguese',
  qu: 'Quechua',
  rm: 'Romansh',
  rn: 'Rundi',
  ro: 'Romanian, Moldavian, Moldovan',
  ru: 'Russian',
  rw: 'Kinyarwanda',
  sc: 'Sardinian',
  sd: 'Sindhi',
  se: 'Northern Sami',
  sg: 'Sango',
  si: 'Sinhala, Sinhalese',
  sk: 'Slovak',
  sl: 'Slovenian',
  sm: 'Samoan',
  sn: 'Shona',
  so: 'Somali',
  sq: 'Albanian',
  sr: 'Serbian',
  ss: 'Swati',
  st: 'Southern Sotho',
  su: 'Sundanese',
  sv: 'Swedish',
  sw: 'Swahili',
  ta: 'Tamil',
  te: 'Telugu',
  tg: 'Tajik',
  th: 'Thai',
  ti: 'Tigrinya',
  tk: 'Turkmen',
  tl: 'Tagalog',
  tn: 'Tswana',
  to: 'Tonga',
  tr: 'Turkish',
  tt: 'Tatar',
  ty: 'Tahitian',
  udm: 'Udmurt',
  ug: 'Uighur, Uyghur',
  uk: 'Ukrainian',
  ur: 'Urdu',
  uz: 'Uzbek',
  vi: 'Vietnamese',
  vo: 'Volapük',
  xh: 'Xhosa',
  xx: '<Placeholder>',
  yi: 'Yiddish',
  yo: 'Yoruba',
  yua: 'Yucatec Maya',
  zh: 'Chinese',
  zu: 'Zulu',
};
